var render = function render(){var _vm=this,_c=_vm._self._c;return _c('global-footer',{staticClass:"footer custom-render",scopedSlots:_vm._u([{key:"links",fn:function(){return undefined},proxy:true},{key:"copyright",fn:function(){return [_c('div',{staticClass:"copyright"},[_vm._v(" Copyright © 2022 北京弘视科技有限公司 ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }